import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";

@Form({title: ""})
export class MessageEditConfig {

	@Input({type: InputType.CHECKBOX, title: "Enable Intent Selection"})
	public showIntent?: boolean;

}



// WEBPACK FOOTER //
// ./src/panels/organizationAdmin/MessageEditConfig.ts